import * as R from "ramda";

export const getLogo = R.pathOr("", ["category", "slug"]);
